export const LOCAL_STORAGE_KEYS = {
  SUBSCRIPTIONS_MODAL_RETURN_URL: "subscriptions_modal_return_url",
  MEDIUM_FETCH_TIME: "medium_fetch_time",
};
